var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "empty-layout"
  }, [_vm._v(" " + _vm._s(_vm.$lang('No Data')) + " ")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };